import autoScroll from 'dom-autoscroller';

const dragula = require('dragula');

/**
 * @param {HTMLElement} container
 * @returns {boolean}
 */
function isGroupArea(container: HTMLElement): boolean {
    return $(container).is('.picture-groups');
}

export default function () {
    const $pictureGroupArea = $(".picture-group-area");

    /*
     * Dragula (drag & drop)
     */
    const drake = dragula({
        isContainer: function (element: HTMLElement) {
            return isGroupArea(element);
        },
        moves: function (element: HTMLElement, source: HTMLElement) {
            if (isGroupArea(source)) {
                return $('.drag-handle', element).length > 0;
            }
            return false;
        },
        accepts: function (el: HTMLElement, target: HTMLElement, source: HTMLElement) {
            if (isGroupArea(source)) {
                return isGroupArea(target);
            }
            return false;
        }
    });

    // Scroll up/down when mouse is about to leave viewport while dragging a group
    autoScroll([window], {
        margin: 500,
        maxSpeed: 1500,
        scrollWhenOutside: true,
        autoScroll: function () {
            return this.down && drake.dragging;
        }
    });

    // Page submission
    $('button[type="submit"]', 'form').parent().on('click', function () {
        const pictureGroups: { [key: string]: number[] }[] = [];
        $('.card-header .group-title', $pictureGroupArea).each(function () {
            const group: { [key: string]: number[] } = {};
            const groupTitle = $(this).text();
            const itemIDs: number[] = [];
            $('img', $(this).closest('.picture-group')).each(function () {
                itemIDs.push($(this).data('item-id'));
            });
            group[groupTitle] = itemIDs;
            pictureGroups.push(group);
        });

        // Everything is fine, set groups data as JSON
        const pictureGroupsJson = JSON.stringify(pictureGroups);
        const $itemInput = $('.group-sorting-element > input[name!="clientTime"]', $(this).closest('form'));
        $itemInput.val(pictureGroupsJson);

        // Set client time
        const date = new Date();
        const $clientTimeInput = $('.group-sorting-element > input[name="clientTime"]', $(this).closest('form'));
        $clientTimeInput.val(date.getTime());
    });
}